import debug from 'debug';
import Api from './Api'

const log = debug('Api:Authenticate');

/**
 * @deprecated use sitecore-api instead, and create missing functionality
 */
class Authenticate extends Api {

	/**
	 * @param {Obejct} options 
	 * @param {string} options.password
	 * @param {boolean} options.persistent
	 * @param {string} options.username
	 * 
	 * @returns {object} user
	 */
	Login(options) {
		log('Login()', options);
		return this.Url({
			url: '/api/authentication/login',
			method: 'POST',
			body: {
				internalsessionid: this.settings.sessionId,
				password: options.password,
				persistent: options.persistent,
				username: options.username
			}
		})
	}

	/**
	 * @returns {Object} _links, minside
	 */
	Profile() {
		return this.Url({
			url: '/api/v7/profile'
		})
	}

}

export default Authenticate;
